import { render, staticRenderFns } from "./BaseCampaignConsents.vue?vue&type=template&id=05d24eb4&scoped=true"
import script from "./BaseCampaignConsents.vue?vue&type=script&lang=js"
export * from "./BaseCampaignConsents.vue?vue&type=script&lang=js"
import style0 from "./BaseCampaignConsents.vue?vue&type=style&index=0&id=05d24eb4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d24eb4",
  null
  
)

export default component.exports